import Model from './Model'

export default class DiaryModel extends Model {
  id!: number

  resource () : string {
    return 'diaries'
  }
}
